import React from "react";
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
import { ActionLinkButton, Icon, PageLayouts, RouteBreadCrumb, StaticInfoMessage } from "components/common";
import { Box, Grid } from "@mui/material";
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

interface VatReportsAvailabilityFailedProps {
  title: string;
  onRetry: () => void;
}

/** Shown when the availability check could not be answered, which says nothing about permission. */
const VatReportsAvailabilityFailed: React.FC<VatReportsAvailabilityFailedProps> = ({ title, onRetry }) => (
  <PageLayouts.DashboardLayout
    entityKey={0}
    title={title}
    breadCrumb={<RouteBreadCrumb className={cssExports.dashBoardNavigation} current={title} />}
  >
    <Grid container item direction="column">
      <StaticInfoMessage displayType={StyleEnums.DisplayType.Danger} surface="background">
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.VatReportsAvailabilityFailed)}
        <Box mt={0.5}>
          <ActionLinkButton
            className={cssExports.animatedLink}
            onClick={onRetry}
            endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.VatReportsRetry)}
          </ActionLinkButton>
        </Box>
      </StaticInfoMessage>
    </Grid>
  </PageLayouts.DashboardLayout>
);

export default VatReportsAvailabilityFailed;
